import React from "react";
import { Spin } from "antd";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import { IOrganisationPresenter } from "../../presenter/OrganisationPresenter";
import OrganisationGrid from "../components/OrganisationGrid";

export interface Props extends PageProps {}

export interface State extends IOrganisationPresenter {}

export default class OrganisationPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      organisations,
      createOrganisation,
      institutions,
      showDetails,
      updateOrganisation
    } = this.state;

    return (
      <Page {...this.props} className={"content-wrapper"}>
        {
          <Spin spinning={this.state.loaders.organisationLoader}>
            <OrganisationGrid
              translate={translate}
              organisations={organisations}
              createOrganisation={createOrganisation}
              referenceLoader={this.state.loaders.organisationLoader}
              institutions={institutions}
              showDetails={showDetails}
              updateOrganisation={updateOrganisation}
            />
          </Spin>
        }
      </Page>
    );
  }
}
